import React from 'react';
import ThronPlayer from './ThronPlayer';
import styled, {css} from 'styled-components';
import { createPortal } from "react-dom";
import themeResponsiveProperty from "./responsive/themeResponsiveProperty";
import RenderOnTablet from "./responsive/RenderOnTablet";
import RenderOnMobile from "./responsive/RenderOnMobile";
import CloseCircle from "../icons/CloseCircle";

export default props => (
  createPortal(
    <Modal>
      <ModalInner>
        <ThronPlayer id={props.asset.contentId} pKey={props.asset.pKey} onPlay={props.onPlay} onComplete={props.onComplete} />
      </ModalInner>

      <CloseButton onClick={props.onCloseButtonClick}>
        <CloseCircle />
      </CloseButton>
    </Modal>,
    window.document.body
  )
)

const Modal = styled.div`
  z-index: 209; // ModalFullScreen is 109
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: env(safe-area-inset-top);
  background-color: rgb(0 0 0 / .7);
  cursor: pointer;
`;

const ModalInner = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

const CloseButton = styled.button`
  z-index: 1;
  position: absolute;
  cursor: pointer;
  top: 0;
  right: 0;
  padding: max(.5rem, env(safe-area-inset-top)) .5rem .5rem;
  border: none;
  background-color: transparent;

  svg {
    width: 2rem;
    color: #fff;
  }
`;
